export enum AppVersionRulePlatform {
    ios = 'ios',
    android = 'android',
    web = 'web',
    electron = 'electron',
}

export enum AppVersionRuleModifier {
    olderOrEqual = '<=',
    equal = '==',
    newerOrEqual = '>=',
}

export enum AppVersionRuleStatus {
    blocked = 'blocked',
    unsafe = 'unsafe',
}

export interface AppVersionRule {
    platform: AppVersionRulePlatform;
    modifier: AppVersionRuleModifier;
    version: string;
    reason: string;
    addedBy: string;
    addedAt: number;
    status: AppVersionRuleStatus;
}
